<template>
  <!-- 在单文件组件中可以通过 .theme-dark .class {} 直接修改深色模式的样式 -->
  <div id="app" class="default" :class="theme">
    <router-view />
  </div>
</template>

<script>
import { checkOperation } from '@/util/checkOperation'
export default { 
  name: 'App',
  data() {
    return {}
  },
  computed: {
    // 计算后添加的全局样式
    theme() {
      return this.$store.getters.isDefaultTheme ? 'theme-default' : 'theme-dark'
    },
  },
  watch: {
    theme: {
      handler: val => {
        // 部分弹出框元素为body子元素，因此将全局样式class也附加到body上
        document.getElementsByTagName('body')[0].className = val
      },
      immediate: true,
    },
  },
  created() {
    // 检查操作 长时间不操作自动退出
    checkOperation()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
#app
  height 100%
  width 100%
</style>
